// Import necessary React hooks
import { useState } from "react";
// Import necessary Material-UI components
import { Box, Typography, Dialog, Container, CssBaseline } from "@mui/material";
// Import custom validation, functions and hooks
import { validateRequestInput } from "../../validation/validateRequestInput.js";
import { useNewRequestContext, useNewRequest } from "../../hooks";
import { EditSampleRequestDetailsForm } from "../../common";
import { createFormRequestDetails } from "../../functions";

/**
 * EditSampleRequestDetailsModal component for editing
 * sample details while submitting a new sample request
 * @param {Object} props - Component props including data, and callbacks.
 */
export function EditSampleRequestDetailsModal(props) {
  // Function to close the modal
  const handleClose = () => props.setOpen(false);
  // State to store any validation errors
  const [errors, setErrors] = useState();
  // Hook to set sample request details
  const { setSampleRequestDetails } = useNewRequest();
  // Hook to access the current state of the new request
  const { state } = useNewRequestContext();

  // State for storing form dropdown Select values
  const [values, setValues] = useState({
    HODDepartmentSelect: state.sampleRequestDetails.HODDepartment,
    executiveChefEmailSelect: state.sampleRequestDetails.executiveChefEmail,
    purposeSelect: state.sampleRequestDetails.purpose,
    endUserLocationSelect: state.sampleRequestDetails.endUserLocation,
    businessUnitSelect: state.sampleRequestDetails.businessUnit,
  });

  // Handler for selecting values from dropdown Selects
  const handleSelect = (id, value) => {
    setValues({ ...values, [id]: value });
  };

  // Function to set the sample request details and close the modal
  const handleSetData = (data) => {
    setSampleRequestDetails({
      ...data,
      items: state.sampleRequestDetails.items,
    });
    setErrors();
    handleClose();
  };

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    // Construct the sample details object from form data, values and state
    const sampleDetails = createFormRequestDetails(state, data, values);
    const { validationErrors, isValid } = validateRequestInput(sampleDetails);
    !isValid && setErrors(validationErrors);

    isValid && handleSetData(sampleDetails);
  };
  errors && console.log({ errors });

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        style={{
          height: "90%",
        }}
        PaperProps={{ sx: { borderRadius: "20px" } }}
      >
        <Box
          sx={{
            display: props.display,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            component="main"
            maxWidth="sm"
            sx={{
              marginTop: 4,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Edit Sample Details
            </Typography>
            <CssBaseline />
            {/* Render form for editing sample request details */}

            <EditSampleRequestDetailsForm
              handleSubmit={handleSubmit}
              handleSelect={handleSelect}
              errors={errors}
            />
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}
